export default __webpack_public_path__ + "static/media/LogoPortfolio.8a681df0.svg";